import { DiscountType, useCoupon } from '@farmersdog/coupons';
import type { UseCouponReturn } from '@farmersdog/coupons/src/useCoupon';

import config from '../../../../config';

export function useCouponData(): UseCouponReturn {
  const { url, referrerRoute } = config.get('tosa.app.coreApi');

  return useCoupon({
    apiUrl: `${url}${referrerRoute}`,
    defaultDiscount: {
      discountType: DiscountType.percentage,
      discountAmount: config.get('features.defaultTrialDiscount'),
    },
  });
}
